import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useImpersonatedUserEmail } from "../stores/impersonatedUser.store.ts";
import { useAuth0 } from "@auth0/auth0-react";

export async function getLoggedInUserInfo(email: string) {
  return (
    await axios.get(
      "https://n8n.thelightgroupusa.com/webhook/VIP/Customer/Info",
      {
        params: { customerEmail: email },
      },
    )
  ).data;
}

export function useLoggedInUserInfo() {
  const { user, isLoading, isAuthenticated } = useAuth0();
  const impersonatedUserEmail = useImpersonatedUserEmail();
  const currentEmail = impersonatedUserEmail ?? user?.email;

  const { isPending, error, data } = useQuery({
    queryKey: ["userInfo", currentEmail],
    queryFn: () => getLoggedInUserInfo(currentEmail),
  });

  return {
    isPending: isPending || isLoading,
    error,
    userInfo: data || null,
    isAuthenticated,
  };
}

export function useActualLoggedInUserInfo() {
  const { isLoading, user } = useAuth0();
  const { isPending, error, data } = useQuery({
    queryKey: ["userInfo", user?.email],
    queryFn: () => getLoggedInUserInfo(user?.email),
  });

  return { isPending: isPending || isLoading, error, userInfo: data || null };
}
